<template>
  <FullScreenDialog
    v-model="dialog"
    without-padding
    title="Altri Costi"
    :route-father="routeFather"
  >
    <template v-slot:header-actions>
      <ExportExcelTable
        :worksheetName="worksheetName"
        :fileName="fileName"
        :fieldsToExport="fieldsToExport"
        :fetch="fetchExcel"
      > </ExportExcelTable>
      <v-btn text link @click="goToNew" :disabled="isLicenseBlocked">
        <v-icon class="mr-2">mdi-plus</v-icon> Nuovo
      </v-btn>
      <v-btn
        icon
        @click="toggleBarcode"
        :color="!!ghost ? 'red' : ''"
      >
        <v-icon>mdi-shield-account-variant</v-icon>
      </v-btn>
    </template>

    <template v-slot:content>
      <div style="width: 100%; height:13%">
        <AdvancedFilter
          style="width:99%; height: 100%"
          v-model="filtersValue"
          :filters="filterTypes"
          :advance-filters="advanceFilters"
          :external-filter="externalFilter"
          @apply-filters="applyFilters"
        >
          <template v-slot:custom-supplierId="{filter}">
            <v-row class="pa-6">
              <v-col>
                <SuppliersAutocomplete
                  v-model="filter.value"
                  :label="filter.label"
                  :return-object="false"
                >
                </SuppliersAutocomplete>
              </v-col>
            </v-row>
          </template>
        </AdvancedFilter>
      </div>
      <div style="height: 87%; overflow-y: hidden" ref="dataTableWrapper">
        <TypeDataTable
          v-model="selected"
          loading-text="Caricamento altri costi..."
          :headers="headers"
          :loading="loading"
          :items="otherCosts"
          :page.sync="page"
          :row-per-page.sync="rowPerPage"
          :total-pages.sync="totalPages"
          :height="dataTableHeight"
          @edit="handleEdit"
          @delete="handleDelete"
          @dblclick="handleEdit"
          :show-select="false"
        >
          <template v-slot:custom-companyName="{ item }">
            {{ item.supplier.businessName }}
          </template>
          <template v-slot:externalFooter>
            <TypeDataTable
              :headers="totalHeader"
              :items="totalRow"
              :show-select="false"
              :show-actions="false"
              disablePagination
            >
            </TypeDataTable>
          </template>
        </TypeDataTable>
      </div>
      <StandardDialog
        v-model="dialogBarcode"
        title="Area Riservata Sviluppatori" 
        :dialog-height="null"
        dialog-max-width="500px"
      >
        <ManualBarcodeInput
          v-model="ghostBarcode"
          scan-your-barcode-message="Immettere Codice" 
          @confirm="activeGhost"
        >
        </ManualBarcodeInput>
      </StandardDialog>
    </template>
  </FullScreenDialog >
</template>

<script>
import FullScreenDialog from '@/components/common/FullScreenDialog.vue'
import StandardMenu from '@/components/common/StandardMenu.vue'
import TypeDataTable from '@/components/common/TypeDataTable.vue'
import AdvancedFilter from "@/components/common/AdvancedFilter.vue";
import StandardDialog from '@/components/common/StandardDialog.vue';
import ManualBarcodeInput from '@/components/common/ManualBarcodeInput.vue';
import otherCostsService from '@/services/otherCosts/otherCosts.service.js'
import operatorService from '@/services/operators/operators.service.js'
import ExportExcelTable from "@/components/common/ExportExcelTable.vue";
import SuppliersAutocomplete from "@/components/common/SuppliersAutocomplete.vue";
import dateUtils from "@/mixins/common/dateUtils"


export default {
  name: "OtherCostsList",
  components: {
    FullScreenDialog,
    TypeDataTable,
    StandardMenu,
    AdvancedFilter,
    StandardDialog,
    ManualBarcodeInput,
    ExportExcelTable,
    SuppliersAutocomplete
  },
  mixins: [dateUtils],
  data: function() {
    let props = this.$router.resolve({name: 'Payments'});

    return {
      dialog: true,
      loadingItems: false,
      loadingHeaders: false,
      routeFather: props.href,
      selected: undefined,
      dataTableHeightValue: 400,
      otherCosts: [],
      headers: [],
      page: 1,
      rowPerPage: 200,
      totalPages: 0,
      resizeListener: undefined,
      filterTypes: [
        { type: 'date', operator: 'between', field: 'emittedAt', name: 'Data Emissione', label: ['Da', 'A'], color: "", value: [undefined, undefined] },
        { type: 'date', operator: 'between', field: 'expirationDate', name: 'Data Scadenza', label: ['Da', 'A'], color: "", value: [undefined, undefined] },
        { type: 'string', operator: 'equal', field: 'documentNumber', name: 'Numero Documento', label: 'Numero Documento', color: "", value: undefined },
        { type: 'cash', operator: 'equal', field: 'amount', name: 'Importo', label: 'Importo', color: "", value: undefined, icon: 'mdi-domain' },
        { type: 'custom', operator: 'equal', field: 'supplierId', name: 'Ragione Sociale', label: 'Ragione Sociale', color: "", value: undefined },
        { type: 'string', operator: 'like', field: 'internalCode', name: 'Codice', label: 'Codice', color: "", value: undefined }
      ],
      advanceFilters: [
        { type: 'date', operator: 'between', field: 'createdAt', name: 'Data Creazione', label: ['Da', 'A'], color: "", value: [undefined, undefined] },
        { type: 'string', operator: 'like', field: 'description', name: 'Descrizione', label: 'Descrizione', color: "", value: undefined },
      ],
      externalFilter: { type: 'string', operator: 'like', field: 'description', name: 'Descrizione', label: 'Descrizione', color: "", value: undefined },
      filtersValue: [
      ],
      totalHeader: [
        { text: 'N°', value: 'count' },
        { text: 'Importo', value: 'sum', type: 'price' },
      ],
      totalRow: [],
      ghost: false,
      dialogBarcode: false,
      ghostBarcode: undefined,
      worksheetName: "Lista Altri Costi",
      fileName: "",
      fieldsToExport: {},
      isLicenseBlocked: undefined
    }
  },
  props: {
    filters: {
      type: Array,
      default: function() {
        return [
        ]
      }
    }
  },
  mounted: function() {
    this.fetchHeaders()
    this.filtersValue = this.filters
    this.fetchOtherCosts()

    this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 150
    this.resizeListener = function() {
      this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 150
    }
    this.resizeListener = this.resizeListener.bind(this)
    window.addEventListener('resize', this.resizeListener)

    this.fileName = "Altri_Costi_" + this._buildDateToExport(new Date()) +
      ".xls";

    this.fieldsToExport = otherCostsService._fieldsToExport()
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.resizeListener)
  },
  methods: {
    fetchOtherCosts() {
      this.loadingItems = true

      let filters = [...this.filtersValue, { operator: 'custom', field: 'ghost', value: this.ghost }]
      otherCostsService.list(this.page, this.rowPerPage, filters).then((results) => {
        if(this.rowPerPage != results.rowPerPage) {
          this.rowPerPage = results.rowPerPage
        }

        if(this.page != results.page) {
          this.page = results.page
        }

        this.totalPages = results.totalPages
        if(this.totalPages < this.page && this.totalPages != 0) {
          this.page = this.totalPages
        }

        this.otherCosts = results.rows
        this.totalRow = results.totalRow 
        this.loadingItems = false
      })
    },
    async fetchExcel(){
      let filters = [...this.filtersValue, { operator: 'custom', field: 'ghost', value: this.ghost }]
      let result = await otherCostsService.list(this.page, 15000, filters)

      let returnRow = {
        description: "TOTALE",
        amount: result.totalRow[0].sum
      }

      return [...result.rows, returnRow]
    },
    fetchHeaders() {
      this.loadingHeaders = true
      otherCostsService.fields().then((headers) => {
        this.headers = headers
        this.loadingHeaders = false
      })
    },
    handleEdit(otherCost) {
      this.$router.push({
        name: 'OtherCostsEditForm',
        params: {
          id: otherCost.id,
          filters: this.filtersValue
        },
        query: {
          pathToGoBack: this.$router.resolve({name: 'OtherCostsList'}).href,
          pathName: 'OtherCostsList'
        }
      })
    },
    handleDelete(otherCost) {
      let confirmed = confirm('Sei sicuro di voler eliminare il costo?')

      if(confirmed) {
        this.loading
        otherCostsService.delete(otherCost).then(() => {
          this.fetchOtherCosts()
          this.loading
        })
      }
    },
    goToNew() {
      this.$router.push({
        name: 'OtherCostsNewForm',
        query: {
          pathToGoBack: this.$router.resolve({name: 'OtherCostsList'}).href
        }
      })
    },
    applyFilters() {
      this.fetchOtherCosts()
    },
    toggleBarcode() {
      this.dialogBarcode = true
    },
    activeGhost(){
      operatorService.canPerformOperation(this.ghostBarcode, "Ghost").then((result) => {
        if (result) {
          this.ghost = !this.ghost      
          this.applyFilters()
        } else {
          alert("Non hai i permessi per eseguire questa azione!")
        }
      }).catch(() => {
        alert("Badge non riconosciuto")
      })
      this.ghostBarcode = undefined
      this.dialogBarcode = false
    },
  },
  computed: {
    loading() {
      return this.loadingItems || this.loadingHeaders
    },
    dataTableHeight() {
      return this.dataTableHeightValue + 'px'
    }
  },
  watch: {
    page() {
      this.fetchOtherCosts()
    },
    rowPerPage() {
      this.fetchOtherCosts()
    },
  },
  isLicenseBlocked: {
    bind: 'isLicenseBlocked'
  }
}
</script>